module.exports = __webpack_public_path__ + "static/media/17-mobile.51d836cb.jpg";